import type { OnboardingData } from "@/stores/onboardingStore";

export type PlanningIssue = { step: 4 | 5; key: string; warning?: boolean };
// Keep these aliases aligned with the server's planning_constraints.py. This
// guides form completion; the server remains authoritative for plan safety.
const SUPPORTED_SPORTS = new Set([
  "running", "run", "trail_running", "trail", "cycling", "bike",
  "swimming", "swim", "strength", "mobility", "triathlon",
]);

export function planningProfileIssues(data: Pick<OnboardingData,
  "active_sports" | "preferred_training_days" | "weekly_hours_available">): PlanningIssue[] {
  const issues: PlanningIssue[] = [];
  const sports = data.active_sports ?? [];
  if (!sports.length) issues.push({ step: 4, key: "planning_setup.sports_required" });
  else if (sports.some(sport => !SUPPORTED_SPORTS.has(sport.trim().toLowerCase()))) {
    issues.push({ step: 4, key: "planning_setup.sports_unsupported", warning: true });
  }
  const days = data.preferred_training_days ?? [];
  if (!days.length || days.some(day => !Number.isInteger(day) || day < 0 || day > 6)
      || new Set(days).size !== days.length) {
    issues.push({ step: 5, key: "planning_setup.days_required" });
  }
  const hours = data.weekly_hours_available;
  if (hours === null || !Number.isInteger(hours) || hours < 1 || hours > 40) {
    issues.push({ step: 5, key: "planning_setup.hours_required" });
  }
  return issues;
}
